export default "__VITE_ASSET__f2dIT7TT__"